<template>
  <v-tabs>
    <v-tab><h2>瀏覽</h2></v-tab>
    <v-tab-item class="pa-1 pa-sm-4">
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0">
          <v-data-table
            :headers="headers"
            item-key="mr_id"
            :items="!isSending ? mRegisters : []"
            class="elevation-4 my-m-register-table"
            :loading="isSending"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            :mobile-breakpoint="tableModes[tableMode].breakpoint"
          >
            <!--  -->
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" @click="handleOnOpenContact(item)">
                mdi-account-box
              </v-icon>
            </template>
            <!--  -->
          </v-data-table>
        </v-col>
      </v-row>
      <!-- Dialog -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title class="pt-2 pb-0 pb-sm-2 pt-sm-4">
            <h3>審核聯絡人資料</h3>
            <v-spacer></v-spacer>
            <v-btn icon color="error" @click="dialog = false">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <!--  -->
          <v-card-text class="pb-0">
            <v-form @submit.prevent="">
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-text-field
                    v-model="contactName"
                    label="姓名"
                    :counter="10"
                    @keydown.prevent=""
                  ></v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0">
                  <v-text-field
                    v-model="contactPhone"
                    label="電話"
                    :counter="18"
                    @keydown.prevent=""
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-text-field
                    v-model="contactLine"
                    label="LineID"
                    :counter="32"
                    @keydown.prevent=""
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-textarea
                    v-model="contactMaterial"
                    label="匯款資料"
                    rows="4"
                    @keydown.prevent=""
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-textarea
                    v-model="contactMemo"
                    label="備註"
                    rows="4"
                    @keydown.prevent=""
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <!--  -->
          <v-card-actions>
            <v-combobox
              label="群組"
              :items="!isSending ? mGroupOptions : []"
              v-model="optionSelected1"
              class="pl-4"
            ></v-combobox>
            <v-spacer></v-spacer>
            <v-btn
              elevation="4"
              color="error"
              @click="handleOnDeleteRegister"
              :disabled="isSending"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn
              elevation="4"
              color="success"
              @click="handleOnPassRegister"
              :disabled="isSending"
            >
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>
          </v-card-actions>
          <!--  -->
          <v-progress-linear
            :active="isSending"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-card>
      </v-dialog>
    </v-tab-item>
  </v-tabs>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    // #region Dialog
    dialog: false,
    contactName: '',
    contactPhone: '',
    contactLine: '',
    contactMaterial: '',
    contactMemo: '',
    contactItem: null,
    optionSelected1: '',
    // #endregion

    // #region Table
    tableSearch: '',
    tableCBSelected: [],
    headers: [
      {
        text: '帳號',
        align: 'start',
        value: 'account'
      },
      {
        text: '密碼',
        align: 'start',
        value: 'password'
      },
      {
        text: '姓名',
        align: 'start',
        value: 'name'
      },
      {
        text: '電話',
        align: 'start',
        value: 'phone'
      },
      {
        text: '',
        align: 'start',
        value: 'actions'
      }
    ],
    // #endregion
    nothing: undefined
  }),
  computed: {
    ...mapState('account', ['user', 'uid']),
    ...mapState('admin', [
      'mGroupOptions',
      'tableModes',
      'tableMode',
      'mRegisters',
      'isSending'
    ])
  },
  methods: {
    ...mapActions('admin', [
      'getAllMemberReigster',
      'passMemberReigster',
      'deleteReigster'
    ]),
    // eslint-disable-next-line no-unused-vars
    handleOnOpenContact(item) {
      this.dialog = true
      this.contactName = item.name
      this.contactPhone = item.phone
      this.contactLine = item.line
      this.contactMaterial = item.material
      this.contactMemo = item.memo

      this.contactItem = item
    },
    // handleOnDialogSave() {},
    handleOnPassRegister() {
      if (!this.contactItem) return
      if (!this.optionSelected1) return
      if (this.optionSelected1 === undefined) return
      const info = {
        account: this.contactItem.account,
        password: this.contactItem.password,
        name: this.contactItem.name,
        phone: this.contactItem.phone,
        line: this.contactItem.line,
        material: this.contactItem.material,
        memo: this.contactItem.memo,
        g_id: this.optionSelected1.value,
        mr_id: this.contactItem.mr_id
      }
      ;(async () => {
        const { user, uid } = this
        await this.passMemberReigster({ info: JSON.stringify(info), user, uid })
        this.dialog = false
      })()
    },
    handleOnDeleteRegister() {
      if (!this.contactItem) return
      ;(async () => {
        const { user, uid } = this
        await this.deleteReigster({ mr_id: this.contactItem.mr_id, user, uid })
        this.dialog = false
      })()
    }
  },
  created() {
    ;(async () => {
      const { user, uid } = this
      this.getAllMemberReigster({ user, uid })
    })()
  }
}
</script>

<style lang="scss">
.my-m-register-table {
  th,
  td {
    font-size: 18px;
  }

  th {
    white-space: nowrap;
  }

  // th:nth-child(3) {
  //   min-width: 65px;
  // }

  // th:nth-child(6) {
  //   min-width: 100px;
  // }
}

@media screen and (max-width: 600px) {
  .my-m-register-table {
    // .v-input {
    //   label,
    //   input {
    //     font-size: 20px;
    //   }
    // }

    th,
    td {
      padding-right: 2px !important;
      padding-left: 4px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
